import { render, staticRenderFns } from "./PlacebirthInput.vue?vue&type=template&id=656c5b46&"
import script from "./PlacebirthInput.vue?vue&type=script&lang=js&"
export * from "./PlacebirthInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports